import { useQuery } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { minutesToMilliseconds } from 'date-fns';

import { apiUrlGenerator } from '../use-api';
import { showResult } from '../utils';

export type TPotentialPatientsCountFilter = {
  fromName?: string;
  fromAgencyDoctorGuid?: string;

  toName?: string;
  toAgencyDoctorGuid?: string;

  language?: string;

  ccm?: boolean;
  pcm?: boolean;
  newlyEnrolledOnly?: boolean;
  followUpOnly?: boolean;
  partialsOnly?: boolean;

  selectedPatientsCount?: number;
  patientsCountToTransfer?: number;
  clinicGuid?: string[];
  parentClinicGuid?: string[];
};

export type TPotentialPatientsCountRes = {
  potentialPatientsCount: number;
};

export const GET_POTENTIAL_PATIENT_COUNT_KEY = 'getPotentialPatientsCountKey';

const getPotentialPatientsCountFn = async (
  filter: TPotentialPatientsCountFilter,
) => {
  const url = 'core-2/transfer-tool/potential-patient-count';
  const { data, error } = await dataService.getList<TPotentialPatientsCountRes>(
    apiUrlGenerator(url, filter),
  );

  if (error) {
    showResult(error);
    throw new Error(error);
  }

  return data;
};

const getPotentialPatientsCountKey = (
  filter: TPotentialPatientsCountFilter,
) => {
  const filterWithoutPotentialPatientsCount: TPotentialPatientsCountFilter = {
    ...filter,
    patientsCountToTransfer: undefined,
  };
  return [GET_POTENTIAL_PATIENT_COUNT_KEY, filterWithoutPotentialPatientsCount];
};

export const useGetPotentialPatientsCount = (
  filter: TPotentialPatientsCountFilter,
) => {
  const filterWithItems: TPotentialPatientsCountFilter = filter;

  const { data, isFetching } = useQuery({
    queryKey: getPotentialPatientsCountKey(filterWithItems),
    queryFn: async () => getPotentialPatientsCountFn(filterWithItems),
    staleTime: minutesToMilliseconds(1),
  });

  return { data, isLoading: isFetching && !data };
};
